import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CheckoutButton } from '../CheckoutButton';
import { HERO_MOCKUP, OFFER_FEATURES } from '../../data/woodworking';
import { PRICE } from '../../data/checkout';

/**
 * Value stack + price (#offer). The hero CTA scrolls here.
 * `#offer-price` and `#offer-cta` drive the mobile sticky bar.
 */
export function OfferSection() {
  return <section id="offer" aria-labelledby="offer-title" className="bg-charcoal py-14 sm:py-20 lg:py-24" data-id="element-165" data-mp="6irfxjk3l7ua">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-166" data-mp="1owvuf0kyquo">
        <SectionHeading id="offer-title" tone="dark" align="center" title="Get the complete furniture plan collection" data-id="element-167" data-mp="3svzqxhjjhha6" />

        <div className="mt-8 grid overflow-hidden rounded-[14px] bg-charcoal-raised shadow-[0_40px_80px_-40px_rgba(0,0,0,0.9)] ring-1 ring-white/10 sm:mt-10 lg:grid-cols-2" data-id="element-168" data-mp="3iyll0bv8saw4">
          <div className="flex items-center justify-center border-b border-white/10 px-6 pb-6 pt-8 sm:px-10 lg:border-b-0 lg:border-r lg:p-10" data-id="element-169" data-mp="3ext8n9r2ppvm">
            <img src={HERO_MOCKUP.src} alt={HERO_MOCKUP.alt} width={HERO_MOCKUP.width} height={HERO_MOCKUP.height} loading="lazy" decoding="async" className="aspect-square w-full max-w-[360px] object-contain sm:max-w-[420px] lg:max-w-none" data-id="element-170" data-mp="1fj8xz39mdcf8" />
          </div>

          <div className="px-5 pb-7 pt-6 sm:px-10 sm:pb-10 sm:pt-9" data-id="element-171" data-mp="1tgp5yj7kde93">
            <p className="wordmark text-[1.25rem] text-ivory sm:text-[1.5rem]" data-id="element-172" data-mp="1yh33367mn3sc">
              Woodworking Furniture Plans<sup className="ml-0.5 font-sans text-[0.5em] font-semibold" data-id="element-173" data-mp="1khk87f3ttoxz">™</sup>
            </p>
            <p className="label-tech mt-3 text-olive-light" data-id="element-174" data-mp="1ohlyks442vxy">60 projects across 6 digital volumes</p>

            <ul className="mt-6 grid gap-3" data-id="element-175" data-mp="91dfn0i0szcl">
              {OFFER_FEATURES.map(feature => <li key={feature} className="flex items-start gap-3 text-[1rem] leading-snug text-ivory" data-id="element-176" data-mp="d5l4qyse4hbc">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-forest text-olive-light ring-1 ring-olive/50" aria-hidden data-id="element-177" data-mp="2ft07bonjywdh">
                    <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-178" data-mp="21214yvdb942c" />
                  </span>
                  {feature}
                </li>)}
            </ul>

            <div id="offer-price" className="mt-7 border-t border-white/10 pt-6 text-center" data-id="element-179" data-mp="1wycsby9tnia8">
              <p className="font-brand text-[3.6rem] font-bold leading-none tracking-[-0.01em] text-ivory sm:text-[4.2rem]" data-id="element-180" data-mp="1s01mdymndrxa">
                {PRICE.label}
              </p>
              <p className="mt-3 text-[0.95rem] text-parchment" data-id="element-181" data-mp="1i4gn488yr5r8">{PRICE.note}</p>
            </div>

            <CheckoutButton id="offer-cta" label={`GET THE COMPLETE COLLECTION — ${PRICE.label}`} size="lg" className="mt-6 w-full" data-id="element-182" data-mp="3heznzl8glczy" />

            <p className="mt-4 text-center text-[0.86rem] leading-relaxed text-muted" data-id="element-183" data-mp="3kxf9um7fpywn">
              Digital furniture plans. Physical furniture, tools, and materials are not included.
            </p>
          </div>
        </div>
      </div>
    </section>;
}